import ColorPicker     from '@widesk-ui/components/form/ColorPicker';
import useDesignTokens from '@/hooks/useDesignTokens';

const MIXED_PATTERN = 'repeating-linear-gradient(45deg, #ff000033 0 4px, #0000ff33 4px 8px)';

/** Bouton compact « pastille + libellé » qui ouvre le sélecteur de couleur. */
export default function ColorButton({ label, value, mixed, onChange, allowClear = true, disabledAlpha }: {
	label: string;
	value?: string;
	mixed?: boolean;
	onChange: (color?: string) => void;
	allowClear?: boolean;
	disabledAlpha?: boolean;
}) {
	const tokens = useDesignTokens();

	const swatch = value
		|| (mixed ? MIXED_PATTERN : `repeating-conic-gradient(${tokens.border.default} 0 25%, transparent 0 50%) 0 0 / 8px 8px`);

	return (
		<ColorPicker
			placement="rightTop"
			allowClear={allowClear}
			disabledAlpha={disabledAlpha}
			value={value}
			showText={false}
			onChangeComplete={onChange}
		>
			<button
				type="button"
				aria-label={`Couleur : ${label}`}
				title={mixed ? 'Plusieurs valeurs' : value?.toUpperCase()}
				style={{
					height: 40,
					padding: '0 10px',
					borderRadius: 8,
					cursor: 'pointer',
					display: 'inline-flex',
					alignItems: 'center',
					gap: 8,
					fontSize: 14,
					color: tokens.text.default,
					border: `1px solid ${mixed ? tokens.color.primary : tokens.border.default}`,
					borderStyle: mixed ? 'dashed' : 'solid',
					background: tokens.surface.elevated,
				}}
			>
				<span
					style={{
						width: 18,
						height: 18,
						borderRadius: '50%',
						flexShrink: 0,
						border: `1px solid ${tokens.border.default}`,
						background: swatch,
					}}
				/>
				{label}
			</button>
		</ColorPicker>
	);
}
